import React, { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import firebase from 'firebase/app';
import { getCurrentPage } from '../store/currentPageReducer';
import { AppContext } from '../App';
import Button from './Button';
import BackArrow from '../icons/BackArrow';
import './Header.scss';

function Header() {
    const currentPage = useSelector(getCurrentPage);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(false);
    }, [currentPage]);

    const context = useContext(AppContext);
    if (!context) {
        return null;
    }
    const { activeUser } = context;

    const handleSignOut = () => {
        firebase.auth().signOut().then(function() {
            console.log('Successfully signed out');
          }).catch(function(error) {
            console.log('An error happened while signing you out ' + error);
          });
    }

    const handleUserMenu = () => {
        setIsOpen(!isOpen);
    }

    const userMenuClasses = classnames('user-menu', {
        'user-menu--hidden': !isOpen
    });

    const userMenu = () => {
        if (activeUser) {
            const photoURL = activeUser.providerData[0].photoURL;
            const name = activeUser.providerData[0].displayName;
            const email = activeUser.providerData[0].email;
            const altText = `${name} Google profile photo`;
            return (
                <div className="user-menu-wrapper">
                    <Button
                        onClick={handleUserMenu}
                        className="button--unstyled"
                    >
                        <img src={photoURL} alt={altText} />
                    </Button>
                    <div className={userMenuClasses}>
                        <img src={photoURL} alt={altText} />
                        <p className="user-menu__name">Hello, {name}!</p>
                        <p className="user-menu__email">{email}</p>

                        <ul>
                            <li><Button onClick={handleSignOut} className="button--border-only--teal button--padding">Sign Out</Button></li>
                        </ul>
                    </div>
                </div>
            )
        }
    }

    switch(currentPage) {
        case '/login':
            return <div></div>;
        case '/addItem':
            return (
                <header className="App-header App-header--with-icon App-header--grid-3">
                    <BackArrow />
                    Add Item
                    {userMenu()}
                </header>
            );
        case '/scan':
            return (
                <header className="App-header App-header--with-icon App-header--grid-3">
                    <BackArrow />
                    Scan an Item
                    {userMenu()}
                </header>
            );
        case '/':
            return (
                <header className="App-header">
                    Inventory
                    {userMenu()}
                </header>
            );
        default:
            return (
                <header className="App-header">Pantry</header>
            );
    }
}

export default Header;